import React, { createRef, useEffect, useState } from "react";
import { useSearch } from "../../../Contexts/SearchContext";
import { getActiveFilters } from "../../../../helpers";
import "./LevelTwoFilterDrawerAccordion.scss";
import Filter from "../Filter/Filter";

const LevelTwoFilterDrawerAccordion = ({
  data,
  index,
  filteredResults,
}) => {
  const { state, dispatch } = useSearch();

  const { selectedFilters, componentElement } = state;

  const [isActive, setIsActive] = useState(false);
  const [filtersHeading, setFiltersHeading] = useState("");

  const $levelTwoElement = createRef();

  let isActiveClass = isActive ? " active" : "";

  useEffect(() => {
    updateHeaderInput();
    updateFiltersHeading();
  }, [selectedFilters]);

  const allFiltersAreSelected = () => {
    const uncheckedSelector = '.cmp-accordion__content-item-level-two input:not(:checked)';
    const $uncheckedFilters = $levelTwoElement.current.querySelectorAll(uncheckedSelector);
    return $uncheckedFilters && $uncheckedFilters.length === 0;
  }

  const updateHeaderInput = () => {
    const $headerInput = $levelTwoElement.current.querySelector('.cmp-accordion__header input');
    $headerInput.checked = allFiltersAreSelected();
  }

  const getSelectedFiltersCount = () => {
    return $levelTwoElement.current.querySelectorAll(".cmp-accordion__content-item-level-two input:checked").length;
  }

  const updateFiltersHeading = () => {
    if (allFiltersAreSelected()) setFiltersHeading("All Selected");
    else {
      const count = getSelectedFiltersCount();
      if (count > 0) setFiltersHeading(`${count} Selected`);
      else setFiltersHeading("");
    }
  }

  const trackFilterCheckForDataLayer = (checkbox) => {
    let filterTitle = checkbox.nextSibling?.textContent;
    if (checkbox.classList.contains("cmp-accordion__header-input")) filterTitle += " (select all)";
    let filterCategory = checkbox
        ?.closest(".cmp-accordion__level-two-item")
        ?.querySelector(".cmp-accordion__title")?.textContent;
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchFilterApplied,
      linkDetails: {
        clickName: 'Search Refinement Actions',
        clickType: `Filter Checkbox ${filterCategory}`,
        clickLocation: 'Product Finder Filter Rail',
        filter: {
          category: `filter by ${filterCategory}`,
          values: filterTitle
        }
      }
    });
  };

  const dispatchActiveFilters = () => {
    dispatch({
      type: "UPDATE_SELECTED_FILTERS",
      payload: getActiveFilters(componentElement, dispatch, "all"),
    });
  }

  const updateFilters = (event) => {
    let checkbox = event.target;
    if (checkbox.checked) trackFilterCheckForDataLayer(checkbox);
    updateFiltersHeading();
    dispatchActiveFilters();
  };

  const updateAllFilters = (event) => {
    const $filters = $levelTwoElement.current.querySelectorAll('.cmp-accordion__content-item-level-two input');
    for (let i = 0; i < $filters.length; i += 1) {
      // Only check the checkbox if it does not have the "checkbox-disabled" class
      if (!$filters[i].classList.contains('checkbox-disabled')) {
        $filters[i].checked = event.target.checked;
      }
    }
    if (event.target.checked) trackFilterCheckForDataLayer(event.target);
    updateFiltersHeading();
    dispatchActiveFilters();
  }

  if (data) {
    return (
      <div
        className={`cmp-accordion__level-two-item${isActive ? " open" : ""}`}
        ref={$levelTwoElement}
      >
        <div className={"cmp-accordion__header"}>
          <div className={"cmp-accordion__header-wrapper"}>
            <input
                type="checkbox"
                className="cmp-accordion__header-input"
                aria-label={`Select all ${data.label} filters.`}
                onChange={(e) => {
                  updateAllFilters(e);
                }}
            />
            <button
              aria-expanded={isActive ? "true" : "false"}
              aria-controls={"accordion-item-" + index}
              className="cmp-accordion__title-button"
              onClick={() => setIsActive(!isActive)}
            >
              <div className="cmp-accordion__dropdown-heading">
                <div className="cmp-accordion__title">{data.label}</div>
                <span className={`chevron${isActiveClass}`}></span>
              </div>
            </button>
          </div>
          <div className="cmp-accordion__selected-filters-heading-level-two">{filtersHeading}</div>
        </div>
        <div
          className="cmp-accordion__content-level-two"
          id={"accordion-item-" + index}
        >
          <ul>
            <li className="cmp-accordion__content-item-level-two">
              {data.filters &&
                data.filters.length > 0 &&
                data.filters.map((filter) => {
                  if (filter && filter.label.trim() !== "") {
                    const count = filteredResults &&
                    filteredResults.length > 0 &&
                    filteredResults.filter((result) => {
                      return (
                        result.Fields.formattedPageTags.Value.indexOf(
                          `"tagId":"${filter.tagPath}"` // match with double quotes
                        ) >= 0
                        || result.Fields.formattedPageTags.Value.indexOf(
                          `'tagId':'${filter.tagPath}'` // match with single quotes
                        ) >= 0
                      );
                    }).length;
                    return (
                      <Filter
                        filter={filter}
                        filteredResults={filteredResults}
                        updateFilters={updateFilters}
                        count={count}
                      />
                    );
                  }
                })}
            </li>
          </ul>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default LevelTwoFilterDrawerAccordion;
